import inView from 'in-view';
import ProgressBar from 'progressbar.js';
import uniqid from 'uniqid';
import * as helpers from '../global/helpers';

const stats = {
	progressBars: [],

	init() {
		// Bind event handlers to this object.
		this.handleProgressEnter = this.handleProgressEnter.bind(this);
		this.handleProgressExit = this.handleProgressExit.bind(this);

		// Create ProgressBar instances.
		this.stats = document.querySelectorAll('.js-progress');
		helpers.forEach(this.stats, (i, stat) => {
			const id = uniqid();
			let progressBar;
			const decimals = this.countDecimals(stat.dataset.progressNumber);

			switch (stat.dataset.progressType) {
				default:
					progressBar = new ProgressBar.Circle(stat, {
						strokeWidth: 5,
						trailWidth: 5,
						easing: 'easeInOut',
						duration: 1400,
						text: {
							autoStyleContainer: false,
						},
						from: {
							numberValue: 0,
						},
						to: {
							numberValue: stat.dataset.progressNumber * 1,
						},
						step: (state, circle) => {
							let text;
							if (stat.dataset.progressPercent) {
								text = `${(circle.value() * 100).toFixed(1).toString()}<sup class="progressbar-text__label progressbar-text__percent">%</sup>`;
							} else {
								text = state.numberValue.toFixed(decimals);
							}

							if (stat.dataset.progressLabel) {
								text += `<div class="progressbar-text__label">${stat.dataset.progressLabel}</div>`;
							}

							circle.setText(text);
						},
					});
					break;
			}

			stat.id = id;
			this.progressBars[id] = progressBar;
		});

		// Setup events for when progress bars come into view.
		inView('.js-progress')
			.on('enter', this.handleProgressEnter)
			.on('exit', this.handleProgressExit);
	},

	handleProgressEnter(el) {
		const progressBar = this.progressBars[el.id];
		progressBar.animate(el.dataset.progressAmount);
	},

	handleProgressExit(el) {
		const progressBar = this.progressBars[el.id];
		progressBar.animate(0);
	},

	countDecimals(value) {
		const numbers = value.toString().split('.');
		if (numbers.length > 1) {
			return numbers[1].length;
		}

		return 0;
	},
};

stats.init();
